<template>
<div class="phone-wrap">
    <div class="phone-inner" v-if="wayType==='phone'">
        <div class="area-wrap">
            <select-country @selectCode="selectCodeHandle" />
            <phone-input @changeErrorTxt="changeErrorTxtHandle" @changePhone="changePhoneHandle" @btnSure="next" />
            <error-tip ref="errorTip" :txt="errorTxt"/>
        </div>
        <button-wrap :has="actBtn" :cover="cover" :txt="$t($loginLangPrefix('userSign.next'))" @btnSure="next" />
    </div>
    <div class="mphone-inner" v-if="wayType==='m-phone'">
        <title-txt :txt="`${$t($loginLangPrefix('userSign.logReg'))}`" />
        <desc-txt :txt="$t($loginLangPrefix('userSign.phPhoneTips'))" />
        <div class="area-wrap mb" @selectCode="selectCodeHandle">
            <select-country mb="mb" @selectCode="selectCodeHandle" />
            <phone-input mb="mb" @changeErrorTxt="changeErrorTxtHandle" @changePhone="changePhoneHandle" />
            <error-tip ref="errorTip" mb="mb" :txt="errorTxt"/>
        </div>
        <button-wrap mb="mb" :has="actBtn" :cover="cover" :txt="$t($loginLangPrefix('userSign.next'))" @btnSure="next" />
    </div>

</div>
</template>
<script>

import error from '../common/error';
import api from '../js/api';

import selectCountry from '../common/select';
import phoneInput from '../common/phoneInput';
import desc from '../common/desc';
import title from '../common/title';
import button from '../common/button';

export default {
    name: 'phoneparent',
    props: {
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            phone: '',
            code: '1',
            errorTxt: '',
            cover: false
        };
    },
    computed: {
        actBtn() {
            return !!this.phone && !this.errorTxt;
        }
    },
    components: {
        'error-tip': error,
        'select-country': selectCountry,
        'phone-input': phoneInput,
        'button-wrap': button,
        'desc-txt': desc,
        'title-txt': title
    },
    methods: {
        changeErrorTxtHandle(txt) {
            this.errorTxt = txt;
        },
        changePhoneHandle(phone) {
            this.phone = phone;
        },
        selectCodeHandle(code) {
            this.code = code;
        },
        next() {
            if (this.phone && !this.errorTxt && !this.cover) {
                this.cover = true;
                const rp = this.phone.replace(/\b(0{1})/gi, '');
                api.userIsExist(`${this.code}${rp}`).then((data) => {
                    // 手机号0开头的去掉0
                    // const rp = this.phone.replace(/\b(0{1})/gi, '');
                    // 12007 12006 12005 账号存在
                    if (data.ret === '12007' || data.ret === '12006' || data.ret === '12005') {
                        this.$emit('inputPhone', 'login', `${this.code}${rp}`, this.code);
                    } else if(data.ret === '12000') {
                        // 12000 新用户输入前几位 为0 的手机号 进行了拦截
                        // 提示 手机号不合法
                        this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginPhoneTips12000'));
                        this.$emit('inputPhone', 'input', `${this.code}${rp}`, this.code);
                    } else {
                        this.$emit('inputPhone', 'reg', `${this.code}${rp}`, this.code);
                    }
                    this.cover = false;
                }).catch((response) => {
                    this.cover = false;
                    if (response.errorMessageTMXTip) {
                        return;
                    }
                    this.errorTxt = this.$t(this.$loginLangPrefix('userSign.sysError'));
                    // this.$emit('inputPhone', 'login', `${this.code}`, this.code);
                });
            }
        }
    },

    beforeMount() {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
 @function rem($n) {
    @return ($n*1rem / 50);
}
.phone-wrap {
    div, input {
        // -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
        outline: none;
        border: 0;
    }
    position: relative;
    width: 100%;
    .area-wrap {
        position: relative;
        width: 100%;
        // height: 30px;
        &.mb {
            margin-top: rem(30);
        }
    }
    .mphone-inner {
        position: relative;
        width: 100%;
    }
}
</style>
